import {createFeatureSelector, createSelector} from "@ngrx/store";
import {BuildingQueueFeatureKey} from "./building-queue.reducer";
import {BuildingQueue} from "../../models/BuildingQueue";

export const BuildingQueueSelector = createFeatureSelector<BuildingQueue[]>(BuildingQueueFeatureKey);
